import React from 'react';
import { Box, Typography, alpha, useTheme } from '@mui/material';
import RouteIcon from '@mui/icons-material/Route';
import ButtonMAIQ from 'app/components/ReusableUIComponents/LowLevelComponents/buttons/ButtonMAIQ';

interface LaunchReadinessIntroProps {
  tourTitle: string;
  stepCount: number;
  onGettingStarted: () => void;
}

const LaunchReadinessIntro: React.FC<LaunchReadinessIntroProps> = ({
  tourTitle,
  stepCount,
  onGettingStarted,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
        py: 4,
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2.5,
          bgcolor: alpha(theme.palette.primary.main, 0.1),
          color: 'primary.main',
        }}
      >
        <RouteIcon sx={{ fontSize: 30 }} />
      </Box>

      <Typography
        component="p"
        sx={{
          fontSize: '0.6875rem',
          fontWeight: 700,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: 'text.secondary',
          mb: 0.75,
        }}
      >
        {tourTitle}
      </Typography>

      <Typography
        component="h2"
        sx={{
          fontSize: '1.375rem',
          fontWeight: 700,
          lineHeight: 1.25,
          color: 'text.primary',
          mb: 1.5,
          maxWidth: 320,
        }}
      >
        Welcome to Launch Readiness
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          fontSize: '0.875rem',
          lineHeight: 1.6,
          maxWidth: 340,
          mb: 1.25,
        }}
      >
        Your dealership is ready to configure. This guided walkthrough covers{' '}
        {stepCount} steps across System setup, Dealer System Setup, and Marketing setup.
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          fontSize: '0.8125rem',
          lineHeight: 1.55,
          maxWidth: 340,
          mb: 3.5,
        }}
      >
        Work at your own pace. Click outside the panel anytime to pause — resume from the
        Launch Readiness button in the header.
      </Typography>

      <ButtonMAIQ
        variant="contained"
        color="primary"
        size="large"
        onClick={onGettingStarted}
        sx={{
          minWidth: 200,
          px: 4,
        }}
      >
        Getting started
      </ButtonMAIQ>
    </Box>
  );
};

export default LaunchReadinessIntro;
